// extracted by mini-css-extract-plugin
export default {"icon":"ArrowDropdown_icon__vzB2g"};